'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

var _constants = require('./constants');

exports.default = {
  toggleBar: {
    width: (0, _reactackleCore.bmodule)(4.5),
    height: (0, _reactackleCore.bmodule)(2),

    state: {
      checked: {
        backgroundColor: _constants.toggleBarBackgroundColorChecked
      },

      unchecked: {
        backgroundColor: _reactackleCore.colorPaletteGrey300
      },

      disabled: {
        backgroundColor: _reactackleCore.colorPaletteGrey200
      }
    }
  },

  toggleThumb: {
    size: (0, _reactackleCore.bmodule)(2.5),
    borderRadius: _reactackleCore.radiusRounded,

    state: {
      checked: {
        backgroundColor: _reactackleCore.colorSecondary
      },

      unchecked: {
        backgroundColor: _reactackleCore.colorPaletteGrey100
      },

      disabled: {
        backgroundColor: _reactackleCore.colorPaletteGrey400
      }
    },

    hoverOffset: 3
  },

  label: {
    toggleLabelSpacing: (0, _reactackleCore.bmodule)(1),
    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5, // Only number's accepted

    state: {
      fontColor: _reactackleCore.bodyFontColor,

      checked: {
        fontColor: _reactackleCore.bodyFontColor
      },

      unchecked: {
        fontColor: _reactackleCore.bodyFontColor
      },

      disabled: {
        fontColor: _reactackleCore.fontColorMedium
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-toggle-button/dist/styles/theme.js
// module id = 874
// module chunks = 0